import { form } from '../formState'
import { useTexts } from '../hooks/useTexts'
import { OrdersType } from './OrdersType'

export function PictureField() {
  const texts = useTexts()

  const {
    field: { value: isChecked },
  } = form.useFormField('includePictureChecked')
  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()
  const formDisabled = submitting || disabled

  return (
    <>
      <form.Checkbox
        label={texts.picture}
        name="includePictureChecked"
        validateOn="blur change"
        disabled={formDisabled}
        testId="driver-assistance-form-picture-field"
      />
      {isChecked && <OrdersType name="includePicture" disabled={formDisabled} />}
    </>
  )
}
